var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6653_1174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 0.703121L1.58485 8.04025C0.567629 9.10679 -5.32997e-07 10.525 -4.74654e-07 12C-4.16312e-07 13.475 0.56763 14.8932 1.58485 15.9597L8.90852 23.2969C9.358 23.7471 9.96761 24 10.6033 24C11.2389 24 11.8485 23.7471 12.298 23.2969C12.7475 22.8467 13 22.2361 13 21.5994C13 20.9627 12.7475 20.3521 12.298 19.9019L4.97274 12.5648C4.82302 12.4147 4.73891 12.2113 4.73891 11.9992C4.73891 11.7871 4.82302 11.5836 4.97274 11.4336L12.298 4.09811C12.7475 3.6479 13 3.0373 13 2.40061C13 1.76393 12.7475 1.15332 12.298 0.703121C11.8485 0.252918 11.2389 -5.42897e-07 10.6033 -5.12192e-07C9.96761 -4.81487e-07 9.35799 0.252918 8.90852 0.703121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6653_1174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackWhite);
export default __webpack_public_path__ + "static/media/chevron-back-white.42732e05dfeb3ab3eef3b69ffce2e59d.svg";
export { ForwardRef as ReactComponent };